/* eslint-disable import/no-cycle */
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import config from 'config';
import reducer from './reducers';
import { fetchDefaultBranding } from './actions/branding';

let enhancer;
const middlewares = [thunk];
if (config.isDevelopment) {
  enhancer = composeWithDevTools(applyMiddleware(...middlewares));
} else {
  enhancer = applyMiddleware(...middlewares);
}

function configureStore() {
  const store = createStore(reducer, undefined, enhancer);
  store.dispatch(fetchDefaultBranding());
  return store;
}
const store = configureStore();
export default store;
